export default {
  data() {
    return {
      withoutHiddenClass: false,
    };
  },
  mounted() {
    // eslint-disable-next-line no-console
    console.log('mounted');
    this.withoutHiddenClass = !/el-popup-parent--hidden/.test(document.body.className);
    document.body.classList.add('el-popup-parent--hidden');
  },
  beforeDestroy() {
    // eslint-disable-next-line no-console
    console.log('destroy');
    if (this.withoutHiddenClass) {
      document.body.classList.remove('el-popup-parent--hidden');
    }
  },
};
